import { Schema as S } from "effect";

/** Validate a vendor operation identifier before inserting it into a URL.
 * @since 1.1.11
 * @example S.decodeUnknownSync(CardReadLogIdSchema)("0123456789abcdef01234567");
 */
export const CardReadLogIdSchema = S.String.check(S.isPattern(/^[a-fA-F0-9]{24}$/));
